import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Phone',
      title: 'Telefone Principal',
      value: '(61) 99691-9001',
      description: 'Diariamente, 6h às 23h',
      action: 'tel:+5561996919001'
    },
    {
      icon: 'Mail',
      title: 'E-mail Comercial',
      value: 'estacaocrdf@gmail.com',
      description: 'Resposta em até 24 horas',
      action: 'mailto:estacaocrdf@gmail.com'
    },
    {
      icon: 'MessageCircle',
      title: 'WhatsApp Business',
      value: '(61) 99876-5432',
      description: 'Atendimento rápido',
      action: 'https://wa.me/5561998765432'
    },
    {
      icon: 'Clock',
      title: 'Horário de Funcionamento',
      value: 'Todos os dias',
      description: '6h às 23h',
      action: null
    }
  ];

  const managementTeam = [
    {
      name: 'Carlos Eduardo Silva',
      role: 'Gerente Geral',
      phone: '(61) 3456-7891',
      email: 'carlos@estacaomarina.com.br',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Marina Santos',
      role: 'Coordenadora Comercial',
      phone: '(61) 3456-7892',
      email: 'marina@estacaomarina.com.br',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Roberto Oliveira',
      role: 'Supervisor de Manutenção',
      phone: '(61) 3456-7893',
      email: 'roberto@estacaomarina.com.br',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    }
  ];

  return (
    <div className="space-y-10">
      {/* Contact Methods */}
      <div className="bg-card rounded-xl shadow-warm p-8 border border-border/50">
        <div className="flex items-center space-x-4 mb-8">
          <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-xl">
            <Icon name="Phone" size={24} className="text-primary-foreground" />
          </div>
          <div>
            <h3 className="text-2xl font-heading font-semibold text-foreground">
              Informações de Contato
            </h3>
            <p className="text-base text-muted-foreground">
              Múltiplas formas de entrar em contato conosco
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6">
          {contactMethods?.map((method, index) => (
            <div
              key={index}
              className={`p-6 rounded-xl border border-border hover:shadow-md transition-all duration-200 ${
                method?.action ? 'cursor-pointer hover:border-primary/30 hover:bg-primary/5' : ''
              }`}
              onClick={() => method?.action && window.open(method?.action, '_blank')}
            >
              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-center w-12 h-12 bg-accent/20 rounded-xl flex-shrink-0">
                  <Icon name={method?.icon} size={20} className="text-accent-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-foreground text-base mb-2">
                    {method?.title}
                  </h4>
                  <p className="text-foreground font-bold text-lg mb-1 break-words">
                    {method?.value}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {method?.description}
                  </p>
                </div>
                {method?.action && (
                  <div className="flex-shrink-0 mt-1">
                    <Icon name="ExternalLink" size={16} className="text-muted-foreground" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Emergency Contact */}
      <div className="bg-warning/10 border border-warning/20 rounded-xl p-8">
        <div className="flex items-start space-x-4">
          <div className="flex items-center justify-center w-12 h-12 bg-warning rounded-xl">
            <Icon name="AlertTriangle" size={20} className="text-warning-foreground" />
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-warning-foreground text-lg mb-3">
              Contato de Emergência
            </h4>
            <p className="text-base text-warning-foreground mb-4">
              Para situações urgentes fora do horário comercial:
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-6">
              <a
                href="tel:+556199887766"
                className="flex items-center space-x-3 text-warning-foreground hover:underline font-semibold text-lg"
              >
                <Icon name="Phone" size={20} />
                <span>(61) 99887-7766</span>
              </a>
              <span className="text-warning-foreground/60 hidden sm:block">•</span>
              <span className="text-base text-warning-foreground font-medium">
                24h para emergências
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;